var _implements = require('util/interface')._implements;

var Metadata = require('../../metadata/metadata');

var MRecordContent = require('./record-content');
var MStateless = require('./stateless');
var MDecimal = require('./decimal');
var MInteger = require('./integer');
var MString = require('./string');
   
module.exports = {
    RecordContent : MRecordContent,
    Stateless : MStateless,
    Decimal : MDecimal,
    Integer : MInteger,
    String : MString
};




//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/metadata/metadata.js
// module id = 512
// module chunks = 1